<template>
  <div class="icon">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
      <path
        class="prefix__arrow"
        d="M28.1 22.4c5.8-5 13.1-7.9 20.7-8.1 19.6 0 35.5 15.9 35.5 35.5S68.4 85.4 48.8 85.4c-15 0-28.4-9.4-33.4-23.5-.8-2.5-3.3-4-5.9-3.6l-4.6 1c-2.4.4-4 2.7-3.5 5.1 0 .1.1.3.1.4 8.1 26.2 36 40.7 62.2 32.5S104.4 61.1 96.2 35C89.7 14.2 70.5.1 48.8.1 37.4.4 26.5 4.7 18 12.3L9.5 3.9C7.7 2 4.7 2 2.8 3.9 2 4.8 1.5 6 1.5 7.2v26c0 2.6 2.1 4.7 4.7 4.7h26c2.6 0 4.7-2.1 4.7-4.7 0-1.3-.5-2.5-1.4-3.3l-7.4-7.5z"
        fill="#003a70" />
    </svg>
  </div>
</template>
